module.exports = __webpack_public_path__ + "static/media/ico_story.2a1aabc6.svg";